"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/patientResponse/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _reactrouterdom = require('react-router-dom');
var _reactdropzone = require('react-dropzone'); var _reactdropzone2 = _interopRequireDefault(_reactdropzone);
var _ExpandingInput = require('web/components/Conversation/ExpandingInput'); var _ExpandingInput2 = _interopRequireDefault(_ExpandingInput);

var _client = require('shared/services/client'); var _client2 = _interopRequireDefault(_client);
var _actions = require('shared/actions'); var _actions2 = _interopRequireDefault(_actions);
var _store = require('web/store');
var _hooks = require('web/services/hooks');

var _uuid = require('shared/services/uuid');
var _patientConversation = require('shared/selectors/patientConversation');
var _peers = require('shared/selectors/peers');
var _currentPatient = require('shared/selectors/currentPatient');
var _org = require('shared/selectors/org');
var _patientApp = require('shared/selectors/patientApp');
var _string = require('shared/services/string');
var _AppPrompts = require('./AppPrompts');
var _PatientPage = require('./PatientPage');
var _PatientThread = require('./PatientThread'); var _PatientThread2 = _interopRequireDefault(_PatientThread);
var _thread = require('./thread');










// The drop zone's hidden file input stays out of the Tab order; the
// composer's Attach control opens it.
const DROPZONE_INPUT_PROPS = { tabIndex: -1 }

// After the connection drops, the page shows the offline strip and
// reconnects by itself, trying again after each delay (the last repeats),
// for this long; then it shows the disconnected screen with Reconnect.
const AUTO_RECONNECT_MS = 30000
const RECONNECT_DELAYS_MS = [0, 1000, 2000, 4000, 8000]



// The most the link socket returns for one window of messages.
const FIRST_PAGE_FILL_LIMIT = 100

// The message a reply answers, as the strip above the message box shows it.






// Copy text: the clipboard API, or a selected hidden field where it is
// missing (an older browser, or a page not served securely).
const copyToClipboard = (text) => {
  if (_optionalChain([navigator, 'access', _ => _.clipboard, 'optionalAccess', _2 => _2.writeText])) {
    navigator.clipboard.writeText(text).catch(() => null)
    return
  }
  const field = document.createElement('textarea')
  field.value = text
  field.setAttribute('readonly', '')
  field.style.position = 'fixed'
  field.style.opacity = '0'
  document.body.appendChild(field)
  field.select()
  document.execCommand('copy')
  field.remove()
}

// What connect()'s mapState gave the class: all undefined until the store
// holds a patient conversation.
function usePatientConversationProps () {
  const patientConversations = _hooks.useAppSelector.call(void 0, _patientConversation.selectPatientConversations)
  const users = _hooks.useAppSelector.call(void 0, _peers.selectAllV1Users)
  const currentPatient = _hooks.useAppSelector.call(void 0, _currentPatient.selectCurrentPatient)

  const conversation = _react.useMemo.call(void 0, 
    () => Object.values(patientConversations)[0],
    [patientConversations],
  )
  const conversationKey = _optionalChain([conversation, 'optionalAccess', _3 => _3.ConversationKey])
  const orgKey = _optionalChain([conversation, 'optionalAccess', _4 => _4.OrgKey])

  const conversationMessages = _hooks.useAppSelector.call(void 0, state =>
    conversationKey ? _patientConversation.selectPatientConversationMessages.call(void 0, state, conversationKey) : undefined,
  )
  const org = _hooks.useAppSelector.call(void 0, state => orgKey ? _org.selectOrgV1.call(void 0, state, orgKey) : null)

  // SAFETY: none; Object.values throws on a missing message list, as
  // mapState did.
  const messages = _react.useMemo.call(void 0, 
    () => conversation ? Object.values(conversationMessages) : undefined,
    [conversation, conversationMessages],
  )

  if (!conversation) return {}

  const [user] = Object.values(users)
  const orgName = orgKey && _optionalChain([org, 'optionalAccess', _5 => _5.Name]) || ''

  return { user, users, patient: currentPatient, conversation, messages, orgName }
}

// Detect iOS Safari for WebSocket disconnect workaround (iOS 26.0.1 bug)
const isIOSSafari = () => {
  // SAFETY: both are optional legacy globals, read only for truthiness.
  const legacyWindow = window 
  const ua = navigator.userAgent || navigator.vendor || legacyWindow.opera || ''
  // Detect iOS device (iPhone, iPad, iPod)
  const isIOS = /iPad|iPhone|iPod/.test(ua) && !legacyWindow.MSStream
  // Detect Safari (not Chrome on iOS - CriOS is Chrome on iOS)
  const isSafari = /Safari/.test(ua) && !/Chrome/.test(ua) && !/CriOS/.test(ua)
  return isIOS && isSafari
}

// Memoized, as connect() was.
const PatientConversation = _react.memo.call(void 0, function PatientConversation () {
  const { user, users, patient, conversation, messages, orgName } = usePatientConversationProps()
  const patients = _hooks.useAppSelector.call(void 0, state => state.patients)
  // The app prompts (Apple's Smart App Banner, the app bar, the manual link)
  // show only for an org known to keep "Patients can use the app" on, so
  // they stay hidden while the org isn't known: loading, an expired or an
  // invalid link (fails closed).
  const isPatientAppOn = _hooks.useAppSelector.call(void 0, state => _patientApp.selectIsPatientAppEnabled.call(void 0, state, _optionalChain([conversation, 'optionalAccess', _6 => _6.OrgKey])))
  const arePromptsOn = _AppPrompts.PATIENT_APP_PROMPTS_ENABLED && isPatientAppOn
  _AppPrompts.useSmartAppBanner.call(void 0, arePromptsOn)

  const [initialLoadComplete, setInitialLoadComplete] = _react.useState.call(void 0, false)
  const [message, setMessage] = _react.useState.call(void 0, "")
  const [isCodeInvalid, setIsCodeInvalid] = _react.useState.call(void 0, false)
  const [isCodeExpired, setIsCodeExpired] = _react.useState.call(void 0, false)
  const [hasLoadFailed, setHasLoadFailed] = _react.useState.call(void 0, false)
  const [connection, setConnection] = _react.useState('online')
  const [replyTo, setReplyTo] = _react.useState(null)
  const [isReconnecting, setIsReconnecting] = _react.useState.call(void 0, false)
  const [renewalRequested, setRenewalRequested] = _react.useState.call(void 0, false)
  // This chat's clinic, from the latest load: kept in memory only, never in
  // the store or browser storage, and replaced on every reload.
  const [clinic, setClinic] = _react.useState(null)
  const isDisconnected = connection === 'disconnected'
  // The app bar and manual link show only on a loaded conversation whose org
  // has the app on (arePromptsOn); an expired or invalid link shows neither.
  const appPrompt = _AppPrompts.useAppPrompt.call(void 0, !isCodeInvalid && !hasLoadFailed && !isDisconnected, arePromptsOn)

  // Instance fields on the class.
  const conversationCodeRef = _react.useRef(undefined)
  const dropzoneRef = _react.useRef(null)
  const composerRef = _react.useRef(null)

  // Socket handlers and callbacks read the latest props and state when they
  // run, as the class read this.props and this.state.
  const latestRef = _react.useRef.call(void 0, { patient, conversation, messages, message, connection, initialLoadComplete, replyTo, users })
  _react.useLayoutEffect.call(void 0, () => {
    latestRef.current = { patient, conversation, messages, message, connection, initialLoadComplete, replyTo, users }
  })
  // The automatic reconnect: when the connection dropped, how many tries so
  // far, and the timers for the next try and for giving up.
  const offlineSinceRef = _react.useRef(null)
  const reconnectTriesRef = _react.useRef.call(void 0, 0)
  const retryTimerRef = _react.useRef(undefined)
  const giveUpTimerRef = _react.useRef(undefined)
  // Messages held per staff sender while that sender loads, in arrival order.
  const pendingSendersRef = _react.useRef.call(void 0, new Map())

  // Ask the backend to text a fresh link to the phone on file. The new link is
  // never returned here (SMS-only, D1); the confirmation is shown regardless of
  // outcome (D3), so set requested state first and swallow any request error.
  const requestNewLink = _react.useCallback.call(void 0, () => {
    setRenewalRequested(true)
    // SAFETY: the expired page only shows once mount has read the code.
    _actions2.default.renewPatientConversationLink(conversationCodeRef.current).catch(() => null)
  }, [])

  // Connects as the patient this link belongs to. The client's own retry
  // reconnects without the code, so a reconnect opens it again with it.
  const openSocket = _react.useCallback.call(void 0, () => {
    _client2.default.open({
      auth: {
        Type: 'patient_code',
        // SAFETY: set on mount before the first open.
        Code: conversationCodeRef.current,
      },
    })
  }, [])

  const reconnect = _react.useCallback.call(void 0, () => {
    if (isReconnecting) return
    setIsReconnecting(true)
    openSocket()
  }, [isReconnecting, openSocket])

  const stopReconnecting = _react.useCallback.call(void 0, () => {
    clearTimeout(retryTimerRef.current)
    clearTimeout(giveUpTimerRef.current)
    offlineSinceRef.current = null
  }, [])

  // The connection dropped. Sends still waiting for an answer can't be
  // confirmed, so they show Retry. With the chat on screen the page goes
  // offline and reconnects by itself; before it loaded, or once that has
  // failed for AUTO_RECONNECT_MS, it shows the disconnected screen.
  const handleClosed = _react.useCallback.call(void 0, () => {
    const latest = latestRef.current
    if (latest.conversation) _actions2.default.interruptPatientConversationSends(latest.conversation.ConversationKey)
    setIsReconnecting(false)

    if (!latest.initialLoadComplete || latest.connection === 'disconnected') {
      stopReconnecting()
      setConnection('disconnected')
      return
    }

    if (offlineSinceRef.current === null) {
      offlineSinceRef.current = Date.now()
      reconnectTriesRef.current = 0
      giveUpTimerRef.current = setTimeout(() => {
        stopReconnecting()
        setConnection('disconnected')
      }, AUTO_RECONNECT_MS)
    }
    setConnection('offline')

    const tries = reconnectTriesRef.current++
    const delay = RECONNECT_DELAYS_MS[Math.min(tries, RECONNECT_DELAYS_MS.length - 1)]
    clearTimeout(retryTimerRef.current)
    // The first try runs now, before the client's own reconnect (which has
    // no link code) can start.
    if (delay === 0) openSocket()
    else retryTimerRef.current = setTimeout(openSocket, delay)
  }, [openSocket, stopReconnecting])

  // The first page is the newest 30 by sequence, but older pages go by time.
  // A burst can store messages out of time order, so some sent within the
  // first page's span aren't in it; load that span by time too, so paging
  // back from its oldest message skips none.
  const fillFirstPage = _react.useCallback.call(void 0, (ConversationKey, firstPage) => {
    const times = firstPage.map(m => new Date(m.SentTimestamp).getTime())
    if (times.length < 2) return
    _actions2.default.getPatientConversationMessages({
      ConversationKey,
      Limit: FIRST_PAGE_FILL_LIMIT,
      BeforeTimestamp: Math.min(...times),
      AfterTimestamp: Math.max(...times) + 1,
    }).catch(() => null)
  }, [])

  // Sends what the patient wrote while offline, oldest first, under the
  // keys it was shown with.
  const sendWaiting = _react.useCallback.call(void 0, () => {
    const { conversation, patient, messages } = latestRef.current
    if (!conversation || !patient) return
    const waiting = (_nullishCoalesce(messages, () => ( []))).filter(row => row.SendState === 'waiting').reverse()
    for (const row of waiting) {
      _actions2.default.sendPatientConversationMessage({
        ConversationKey: conversation.ConversationKey,
        PatientKey: patient.PatientKey,
        Text: _nullishCoalesce(row.TextContent, () => ( '')),
        MessageKey: row.MessageKey ,
        // A reply written offline is still a reply.
        ...(row.ReplyToMessageKey && { ReplyToMessageKey: row.ReplyToMessageKey }),
      }, row.LocalKey).catch(() => null)
    }
  }, [])

  const markSeen = _react.useCallback.call(void 0, (conversationKey) => {
    const key = conversationKey || _optionalChain([latestRef, 'access', _7 => _7.current, 'access', _8 => _8.conversation, 'optionalAccess', _9 => _9.ConversationKey])
    if (!key) return

    _actions2.default.markPatientConversationSeen({ ConversationKey: key }).catch(() => null)
  }, [])

  // A staff member who joined after the page loaded isn't in the store. Their
  // message waits until the newest page of messages, which comes back with
  // the chat's users, has loaded them, so it never shows as "Unknown User?".
  // Later messages from them (a recall included) wait behind it, in order.
  const receiveMessage = _react.useCallback.call(void 0, (incoming) => {
    const deliver = () => {
      _actions2.default.handleIncomingPatientMessageNotification(incoming)
      markSeen()
    }
    const userKey = incoming.FromUserKey
    const pending = pendingSendersRef.current
    const known = latestRef.current.users
    let held = pending.get(userKey)
    if (!held) {
      if (!userKey || userKey === _uuid.EMPTY_BLUID || !known || userKey in known) {
        deliver()
        return
      }
      held = _actions2.default.getPatientConversationMessages({
        ConversationKey: incoming.ConversationKey,
        Limit: 1,
        // The backend reads AfterTimestamp as the window's exclusive end.
        AfterTimestamp: new Date(incoming.SentTimestamp).getTime() + 1,
      }).catch(() => null)
    }
    const next = held.then(deliver)
    pending.set(userKey, next)
    next.finally(() => {
      if (pending.get(userKey) === next) pending.delete(userKey)
    }).catch(() => null)
  }, [markSeen])

  // Mount-only, as componentDidMount was: its callbacks never change. The
  // socket handlers come off on unmount.
  _react.useEffect.call(void 0, () => {
    // SAFETY: none; throws when the path has no code, as the class did.
    const conversationCode = _store.history.location.pathname.match(/conversation\/([a-zA-Z0-9]{12}).?/)[1]
    if (!conversationCode) {
      return
    }
    conversationCodeRef.current = conversationCode

    // The socket delivers Data untyped; each Command narrows it.
    const onInbound = (msg) => {
      switch (msg.Command) {
        case 'IncomingPatientMessage': {
          // SAFETY: an IncomingPatientMessage carries this payload.
          receiveMessage(msg.Data )
          break
        }
        case 'DeletedPatientMessageNotification':
          // SAFETY: a DeletedPatientMessageNotification carries this payload.
          _actions2.default.handleDeletedPatientMessageNotification(msg.Data )
          break
      }
    }

    const onAuthenticated = () => {
      // Connected again: a reconnect returns to the conversation, which
      // reloads below, then sends what was written offline.
      stopReconnecting()
      setConnection('online')
      setIsReconnecting(false)
      _actions2.default.loadPatientConversationByCode({ ConversationCode: conversationCode })
        .then(r => {
          setClinic(_nullishCoalesce(r.Clinic, () => ( null)))
          const conversationKey = _optionalChain([Object, 'access', _10 => _10.values, 'call', _11 => _11(r.PatientConversations), 'access', _12 => _12[0], 'optionalAccess', _13 => _13.ConversationKey])
          markSeen(conversationKey)
          if (conversationKey) fillFirstPage(conversationKey, _nullishCoalesce(r.PatientConversationMessages, () => ( [])))
        })
        .then(() => {
          setInitialLoadComplete(true)
          sendWaiting()
        })
        .catch(() => setHasLoadFailed(true))
    }

    const onAuthenticationError = ({ Error }) => {
      stopReconnecting()
      setIsCodeInvalid(Error === "Invalid Code")
      setIsCodeExpired(Error === "Expired Code")
      setConnection('online')
      setIsReconnecting(false)
    }

    _client2.default.on('inbound', onInbound)
    _client2.default.on('authentication-success', onAuthenticated)
    _client2.default.on('authentication-error', onAuthenticationError)
    _client2.default.on('unexpected-closed', handleClosed)

    /* TODO: Move this into a more general place with client upgrade */
    openSocket()

    return () => {
      _client2.default.off('inbound', onInbound)
      _client2.default.off('authentication-success', onAuthenticated)
      _client2.default.off('authentication-error', onAuthenticationError)
      _client2.default.off('unexpected-closed', handleClosed)
    }
  }, [markSeen, openSocket, receiveMessage, handleClosed, sendWaiting, stopReconnecting, fillFirstPage])

  _react.useEffect.call(void 0, () => stopReconnecting, [stopReconnecting])

  // Sends text under a key the page picks, so a retry can't post it twice.
  // Offline, it waits and goes once the page reconnects.
  const sendText = _react.useCallback.call(void 0, (Text, MessageKey, ReplyToMessageKey, lid) => {
    const latest = latestRef.current
    // SAFETY: mapState only gave a patient along with a conversation.
    const request = {
      ConversationKey: latest.conversation.ConversationKey,
      PatientKey: latest.patient.PatientKey,
      Text,
      MessageKey,
      ...(ReplyToMessageKey && { ReplyToMessageKey }),
    }
    if (latest.connection === 'online') {
      _actions2.default.sendPatientConversationMessage(request, lid).catch(() => null)
    } else {
      _actions2.default.holdPatientConversationMessage(request, lid)
    }
  }, [])

  const sendMessage = _react.useCallback.call(void 0, () => {
    const latest = latestRef.current
    if (!latest.patient || _string.isBlank.call(void 0, latest.message)) return
    sendText(latest.message, _uuid.uuidv4.call(void 0, ) , _optionalChain([latest, 'access', _14 => _14.replyTo, 'optionalAccess', _15 => _15.messageKey]))
    setReplyTo(null)
  }, [sendText])

  const retrySend = _react.useCallback.call(void 0, (row) => {
    if (!latestRef.current.patient) return
    sendText(_nullishCoalesce(row.TextContent, () => ( '')), row.MessageKey , row.ReplyToMessageKey, row.LocalKey)
  }, [sendText])

  // Adds the patient's reaction, or takes it away when it is already theirs.
  const react = _react.useCallback.call(void 0, (row, emoji) => {
    const { conversation } = latestRef.current
    if (!conversation) return
    const mine = !!_optionalChain([row, 'access', _16 => _16.Reactions, 'optionalAccess', _17 => _17.some, 'call', _18 => _18(r => r.Emoji === emoji && r.Mine)])
    _actions2.default.togglePatientMessageReaction({
      ConversationKey: conversation.ConversationKey,
      MessageKey: row.MessageKey ,
      Emoji: emoji,
    }, !mine).catch(() => null)
  }, [])

  // Reply opens the strip above the message box and puts the caret there.
  const startReply = _react.useCallback.call(void 0, (item) => {
    setReplyTo({
      messageKey: item.row.MessageKey ,
      name: item.mine ? 'yourself' : item.senderName || 'the clinic',
      text: _thread.summaryOf.call(void 0, item.row),
    })
    _optionalChain([composerRef, 'access', _19 => _19.current, 'optionalAccess', _20 => _20.focus, 'call', _21 => _21()])
  }, [])
  const cancelReply = _react.useCallback.call(void 0, () => {
    setReplyTo(null)
    _optionalChain([composerRef, 'access', _22 => _22.current, 'optionalAccess', _23 => _23.focus, 'call', _24 => _24()])
  }, [])

  const copyText = _react.useCallback.call(void 0, (row) => {
    copyToClipboard(_nullishCoalesce(row.TextContent, () => ( '')))
  }, [])

  const sendFile = _react.useCallback.call(void 0, (file) => {
    const latest = latestRef.current
    if (!latest.patient) return

    return _actions2.default.sendPatientConversationFile({
      ConversationKey: latest.conversation.ConversationKey,
      PatientKey: latest.patient.PatientKey,
      file,
    }).catch(() => null)
  }, [])

  const onDrop = _react.useCallback.call(void 0, (accepted) => {
    if (!latestRef.current.patient) return

    accepted.forEach((f) => {
      sendFile(f)
    })
  }, [sendFile])

  const onChangeInputValue = _react.useCallback.call(void 0, (_e, v) => setMessage(v), [])
  // SAFETY: the Dropzone is mounted whenever the composer is.
  const openDropzone = _react.useCallback.call(void 0, () => dropzoneRef.current.open(), [])

  // Resolves with how many older messages came, 0 at the start of the chat.
  const loadPriorChats = _react.useCallback.call(void 0, () => {
    const latest = latestRef.current
    // The oldest message the server has; rows the page is still sending are newer.
    const oldest = _optionalChain([latest, 'access', _25 => _25.messages, 'optionalAccess', _26 => _26.findLast, 'call', _27 => _27(row => !row.SendState && !row.LocalKey)])
    if (!oldest || !latest.conversation) return Promise.resolve(0)

    // The link socket reads BeforeTimestamp as the window's start and
    // AfterTimestamp as its exclusive end, newest first: so the 30 messages
    // before the oldest are the window that ends at it.
    return _actions2.default.getPatientConversationMessages({
      ConversationKey: latest.conversation.ConversationKey,
      Limit: 30,
      AfterTimestamp: new Date(oldest.SentTimestamp).getTime(),
    })
      .then(r => _nullishCoalesce(_optionalChain([r, 'access', _28 => _28.PatientConversationMessages, 'optionalAccess', _29 => _29.length]), () => ( 0)))
  }, [])

  const threadItems = _react.useMemo.call(void 0, 
    () => initialLoadComplete && messages
      ? _thread.buildThread.call(void 0, messages, { users, patients, currentPatientKey: _optionalChain([patient, 'optionalAccess', _30 => _30.PatientKey]) })
      : null,
    [initialLoadComplete, messages, users, patients, patient],
  )

  // Until the conversation loads, a disabled message box holds its place,
  // so the thread doesn't move when it arrives.
  const canRespond = conversation ? conversation.PatientCanRespond : !initialLoadComplete

  if (isCodeInvalid || isCodeExpired || hasLoadFailed || isDisconnected) {
    return (
      _react2.default.createElement(_PatientPage.PatientPage, {
        caption: "Secure messaging" ,
        prompt: appPrompt,
        className: "patient-conversation--error", __self: this, __source: {fileName: _jsxFileName, lineNumber: 492}}

        , _react2.default.createElement('div', { className: "patient-conversation--error-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 497}}
          ,  isCodeInvalid && "Your chat link is invalid" 
          ,  isCodeExpired && renewalRequested && (
            _react2.default.createElement(_react2.default.Fragment, null
              , _react2.default.createElement('div', { className: "patient-conversation--error-check", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 501}}
                , _react2.default.createElement('svg', { viewBox: "0 0 52 52"   , width: "56", height: "56", __self: this, __source: {fileName: _jsxFileName, lineNumber: 502}}
                  , _react2.default.createElement('circle', { cx: "26", cy: "26", r: "24", fill: "none", stroke: "currentColor", strokeWidth: "3", __self: this, __source: {fileName: _jsxFileName, lineNumber: 503}} )
                  , _react2.default.createElement('path', { fill: "none", stroke: "currentColor", strokeWidth: "4", strokeLinecap: "round", strokeLinejoin: "round", d: "M15 27l8 8 15-16"   , __self: this, __source: {fileName: _jsxFileName, lineNumber: 504}} )
                )
              ), "New link sent"

            )
          ) 
          ,  isCodeExpired && !renewalRequested && "Your chat link has expired" 
          ,  hasLoadFailed && "Your chat failed to load" 
          ,  isDisconnected && "Your chat was disconnected" 
        )
        ,  isDisconnected && (
          _react2.default.createElement('div', { className: "patient-conversation--error-action patient-conversation--error-action--reconnect" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 515}}
            /* aria-disabled, not disabled, so focus stays on it while it
                reconnects. */
            , _react2.default.createElement('button', {
              type: "button",
              className: "patient-conversation--error-renew-button",
              onClick: reconnect,
              'aria-disabled': isReconnecting, __self: this, __source: {fileName: _jsxFileName, lineNumber: 518}}

              ,  isReconnecting ? "Reconnecting…" : "Reconnect" 
            )
          )
        )
        , _react2.default.createElement('div', { className: "patient-conversation--error-desc", __self: this, __source: {fileName: _jsxFileName, lineNumber: 528}}
          ,  isCodeInvalid && "Please request a new link from your provider." 
          ,  isCodeExpired && !renewalRequested && "Tap the button below and we'll text a new link to the phone number on file." 
          ,  isCodeExpired && renewalRequested && "Check your phone for an updated link." 
          ,  hasLoadFailed && "Please try again, or request a new link from your provider." 
          ,  isDisconnected && isIOSSafari() && (
            _react2.default.createElement('a', {
              href: "https://www.notion.so/bloomapi/iOS-Issue-Resolution-2825266d0d4f808f9712da1d5bcc7982?source=copy_link",
              target: "_blank",
              rel: "noopener noreferrer" ,
              className: "patient-conversation--error-help-link", __self: this, __source: {fileName: _jsxFileName, lineNumber: 534}}
, "Having trouble reconnecting? Click here for iOS troubleshooting steps."

            )
          )
        )
        ,  isCodeExpired && (
          _react2.default.createElement('div', { className: "patient-conversation--error-action", __self: this, __source: {fileName: _jsxFileName, lineNumber: 545}}
            ,  renewalRequested ? (
              _react2.default.createElement('div', { className: "patient-conversation--error-renewal-confirmation", __self: this, __source: {fileName: _jsxFileName, lineNumber: 547}}, "Didn't get it? Contact your provider for a new link."

              )
            ) : (
              _react2.default.createElement('button', {
                type: "button",
                className: "patient-conversation--error-renew-button",
                onClick: requestNewLink, __self: this, __source: {fileName: _jsxFileName, lineNumber: 551}}
, "Text me a new link"

              )
            )
          )
        )
      )
    )
  }

  return (
    _react2.default.createElement(_reactrouterdom.Router, { history: _store.history, __self: this, __source: {fileName: _jsxFileName, lineNumber: 566}}
      , _react2.default.createElement(_PatientPage.PatientPage, {
        // Until the provider loads, the caption row holds its place empty.
        caption: user ? (
          _react2.default.createElement(_react2.default.Fragment, null
            , _react2.default.createElement('span', { className: "patient-page--caption-from", __self: this, __source: {fileName: _jsxFileName, lineNumber: 571}}, "From:")
            , ' '
            , _react2.default.createElement('span', { className: "patient-page--caption-name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 573}},  orgName )
          )
        ) : '\u00a0',
        prompt: appPrompt,
        clinic: clinic,
        className: "patient-conversation", __self: this, __source: {fileName: _jsxFileName, lineNumber: 567}}

        ,  connection === 'offline' && (
          _react2.default.createElement('div', { className: "patient-conversation--offline", role: "status", __self: this, __source: {fileName: _jsxFileName, lineNumber: 581}}
            , _react2.default.createElement('i', { className: "material-icons", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 582}}, "wifi_off"), "Offline. Messages will send when you reconnect."

          )
        )
        , _react2.default.createElement(_reactdropzone2.default, {
          disableClick: true,
          onDrop: onDrop,
          ref: dropzoneRef,
          className: "patient-conversation--dropzone",
          inputProps: DROPZONE_INPUT_PROPS, __self: this, __source: {fileName: _jsxFileName, lineNumber: 586}}

          , _react2.default.createElement(_PatientThread2.default, {
            items: threadItems,
            onLoadOlder: loadPriorChats,
            onRetry: retrySend,
            onReact: react,
            onReply: canRespond ? startReply : null,
            onCopy: copyText, __self: this, __source: {fileName: _jsxFileName, lineNumber: 593}}
          )
        )
        , _react2.default.createElement('div', { className: "patient-conversation--input-wrapper", __self: this, __source: {fileName: _jsxFileName, lineNumber: 602}}
          ,  canRespond && replyTo && (
            _react2.default.createElement('div', { className: "patient-conversation--reply", __self: this, __source: {fileName: _jsxFileName, lineNumber: 604}}
              , _react2.default.createElement('i', { className: "material-icons", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 605}}, "reply")
              , _react2.default.createElement('div', { className: "patient-conversation--reply-text", __self: this, __source: {fileName: _jsxFileName, lineNumber: 606}}
                , _react2.default.createElement('span', { className: "patient-conversation--reply-label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 607}}, "Replying to "  ,  replyTo.name )
                , _react2.default.createElement('span', { className: "patient-conversation--reply-quote", __self: this, __source: {fileName: _jsxFileName, lineNumber: 608}},  replyTo.text )
              )
              , _react2.default.createElement('button', {
                type: "button",
                className: "patient-conversation--reply-cancel",
                'aria-label': "Cancel reply" ,
                onClick: cancelReply, __self: this, __source: {fileName: _jsxFileName, lineNumber: 610}}

                , _react2.default.createElement('i', { className: "material-icons", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 616}}, "close")
              )
            )
          )
          ,  canRespond && (
            _react2.default.createElement(_ExpandingInput2.default, {
              ref: composerRef,
              className: "patient-conversation--input",
              disabled: !patient || !initialLoadComplete,
              onChange: onChangeInputValue,
              onAttachmentClick: openDropzone,
              onPasteFiles: onDrop,
              onSend: sendMessage,
              value: message, __self: this, __source: {fileName: _jsxFileName, lineNumber: 621}}
            )
          )
        )
      )
    )
  )
})

exports. default = PatientConversation
